export default __webpack_public_path__ + "static/media/contact-03.7819f4cf.png";